import { render } from "./404.vue?vue&type=template&id=42864338"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=42864338&lang=scss"
script.render = render

export default script